/**
 * 서버에 배포된 앱 버전과 현재 로드된 번들의 버전을 비교하여,
 * 다르면 강제 새로고침하여 항상 최신 버전을 사용하도록 함.
 */
const VERSION_URL = '/version.json';

const getCurrentVersion = () => process.env.REACT_APP_BUILD_ID;

export const checkVersionAndReload = async () => {
  const currentVersion = getCurrentVersion();
  if (!currentVersion) return; // 개발 빌드 등으로 버전이 없으면 스킵

  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
      cache: 'no-store',
      headers: { Pragma: 'no-cache' },
    });
    if (!res.ok) return;
    const data = await res.json();
    const serverVersion = data?.version;
    if (serverVersion != null && String(serverVersion) !== String(currentVersion)) {
      window.location.reload();
    }
  } catch {
    // 네트워크 오류 등은 무시 (오프라인 등)
  }
};
